import { WizardStateBlock } from '../../../components/StepperWizard/WizardStateBlock';

export interface WizardProgressProps {
  step: number;
}

export const WizardProgress = ({ step }: WizardProgressProps) => {
  return (
    <div className="mb-6 grid grid-cols-3 items-end gap-1 text-xs lg:mb-12">
      <WizardStateBlock
        label="Get started"
        isActive={step >= 1}
        isCompleted={step > 1}
        classNames="tech-product-tour-step-1"
      />
      <WizardStateBlock
        label="Add ticket details"
        isActive={step >= 2}
        isCompleted={step > 2}
        classNames="tech-product-tour-step-2"
      />
      <WizardStateBlock
        label="Finalize & review your ticket"
        isActive={step >= 3}
        isCompleted={step > 3}
        classNames="tech-product-tour-step-4"
      />
    </div>
  );
};
